import React from 'react';
import cn from 'classnames';
import IconClose from '@creditflowresearch/uilib/Icon/IconClose';
import styles from './clearButton.module.scss';

interface IProps {
  isSmall: boolean,
  clear: () => void,
  visible: boolean,
}

const ClearButton = ({ isSmall, visible, clear }: IProps) => {
  return (
    <div
      className={ cn(styles.clearButtonWrp, {
        [styles.small]: isSmall,
      }) }
    >
      { visible ? (
        <div
          className={ cn(styles.clearableBtn, { [styles.small]: isSmall }) }
          onClick={ clear }
        >
          <IconClose />
        </div>
      ) : null }
    </div>
  );
};

export default React.memo(ClearButton);
